import React from "react";
import PropTypes from "prop-types";
const NoticeUpdateIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 26 25"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(0 2)">
      <path d="M0 0h24v24H0z" />
      <g
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M1 5v6h6M21 22v-6h-6" />
        <path d="M20.49 10A9 9 0 0 0 5.64 6.64L1 11m19.935 5.94l-2.575 2.42A9 9 0 0 1 3.51 16" />
      </g>
      <circle
        cx="18"
        cy="6"
        r="7"
        fill={color || "var(--color-easil-gray-x-dark)"}
        stroke="#F8FBFF"
        strokeWidth="2"
      />
      <path
        fill="#F8FBFF"
        fillRule="nonzero"
        d="M17.2 3a.8.8 0 1 1 1.6 0v3a.8.8 0 1 1-1.6 0V3zm.8 6.6A.8.8 0 1 1 18 8a.8.8 0 0 1 0 1.6z"
      />
    </g>
  </svg>
);
NoticeUpdateIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default NoticeUpdateIcon;
